<router-outlet></router-outlet>

<tvcore-loader></tvcore-loader>

<tvsub-online-status></tvsub-online-status>
